/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_DescriptionInputs */

const es_components_upgrade_plan_modal_plans_pay_as_you_go_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base mensual con límites abiertos y un esquema flexible para necesidades especiales.`)
};

const en_components_upgrade_plan_modal_plans_pay_as_you_go_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly base pricing with open limits and flexible billing for specialized needs.`)
};

/**
* | output |
* | --- |
* | "Monthly base pricing with open limits and flexible billing for specialized needs." |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_pay_as_you_go_description = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Pay_As_You_Go_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_pay_as_you_go_description(inputs)
	return en_components_upgrade_plan_modal_plans_pay_as_you_go_description(inputs)
});
export { components_upgrade_plan_modal_plans_pay_as_you_go_description as "components.upgrade_plan_modal.plans.pay_as_you_go.description" }